const videoLoading = () => {

  const sections = document.querySelectorAll(".s-text-and-media.--video");
  sections.forEach(section => {
    const medias = section.querySelectorAll(".s-text-and-media__placeholder");
    medias.forEach(media => {
      media.addEventListener("click", () => {
        media = media.parentNode;
        const iframe = media.querySelector("iframe");
        const src = iframe.getAttribute('data-video-src');
        const iframeParent = iframe.parentNode;

        iframe.src = src;
        iframeParent.classList.add("--visible")
        iframeParent.previousElementSibling.classList.add("--unvisible")
      })
    });

  });
}

videoLoading();
